module.exports = __webpack_public_path__ + "img/bg3.fd816843.png";